<template>

  <div class="contenedor">
    <b-card class="contenedor">
      <div slot="header">
        <strong>
          <center>Sga</center>
        </strong>
      </div>
      <table border="0" style="width:80%;border-collapse:collapse;margin:auto;" class="table table-condensed">
        <tr>
          <th width="100%" id="pel-fisico">
            Indicaciones de peligro
          </th>
        </tr>
        <tr>
          <td style="font-size:12px;">
            <select class="inp_form sel_multiple2grande sel_let_peq" :disabled="disabledInputs" multiple="" v-model="selectedSgaEt.codigos" style="height:220px;font-size:14px; width:100%;">
              <option v-for="(frase,index) in jsonSga" :key="index" :value="frase.codigo" v-text="frase.codigo+' - '+frase.descripcion"></option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="font-size:12px;">
            <div v-if="categorias.length > 0">
              <h4>
                <center>Listado de categorias repetidas</center>
              </h4>
              <h6 style="color:red;">Las categorias eliminadas seran eliminadas segun su criterio, esto es necesario para el buen funcionamiento de SGA <span style="font-style: italic;font-size:8pt;">(Una vez eliminada la categoria no se volveran a mostrar, a menos de que vuelva a guardar los codigos de SGA.)</span>
              </h6>
              <ul v-for="(categoria, index) in categorias" :key="index">
                <li>
                  <table>
                    <tr>
                      <th width="120">{{ categoria.codigo }}</th>
                      <td width="450">
                        <span style="font-style: italic;font-size:7pt;">{{ categoria.id }}</span>
                        {{ categoria.categoria }}
                      </td>
                      <td>
                        <b-button variant="danger" @click="eliminarCategoria(categoria.id)">X</b-button>
                      </td>
                    </tr>
                  </table>
                </li>
              </ul>
            </div>
          </td>
        </tr>
        <!-- <tr>
            <td>
                <div v-for="(cod, indexCodigos) in codigosRepetidos" :key="indexCodigos" style="width:100px;float:left;">
                    {{cod}}
                </div>
            </td>
        </tr> -->
      </table>
      <br>
      <center>
        <b-button v-if="selectedProductEt.finalizado == 0" variant="primary" @click="guardarSga"><i class="fa fa-save"></i> Guardar</b-button>
      </center>
    </b-card>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import loader from "../../../../containers/loader";

export default {
  name: 'Sga',
  components: {
    loader
  },
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState('sga_et', [
      'selectedSgaEt',
      'jsonSga',
      'categorias',
      'codigosRepetidos'
    ]),
    ...mapState('productos_et', [
      'selectedProductEt',
      'estados',
      'control_existe',
      'accion'
    ])
  },
  methods: {
    async guardaSga() {
      this.load(true);
      await this.guardarSga();
      await this.getFrases();
      this.load(false);
    },
    ...mapActions('sga_et', [
      'getJsonSga',
      'guardarSga',
      'eliminarCategoria',
      'getFrases'
    ]),
    ...mapMutations('dashboard', [
      'load'
    ]),
  }
}
</script>

<style>
#pel-fisico {
  text-align: center;
  background: #00645a;
  color: white;
}

#pel-salud {
  text-align: center;
  background: #1f487b;
  color: white;
}

#pel-ambiente {
  text-align: center;
  background: #36b564;
  color: white;
}

#sus-peligrosas {
  text-align: center;
  background: #55b543;
  color: white;
}
</style>
